import React from 'react';
import { Reveal } from './Reveal';
import { PriceOffer } from './PriceOffer';
import { volumes, bonuses } from '../data/content';
export function InsideSection() {
  return <section className="w-full bg-navy-800 py-20 lg:py-24" aria-labelledby="inside-heading" style={{
    paddingTop: "4px",
    paddingBottom: "4px"
  }} data-id="element-77" data-mp="3jz4nk3oe3kd8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-78" data-mp="3ox67srxjxpqa">
        <Reveal className="max-w-3xl" data-id="element-79" data-mp="3a0xahvx81mgi">
          <p className="text-sm font-bold uppercase tracking-widest text-brand-gold" data-id="element-80" data-mp="39zvvxhgzyhu1">The library</p>
          <h2 id="inside-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-81" data-mp="3f132xebbfczn">
            Here&rsquo;s exactly what you&rsquo;re getting
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-82" data-mp="360502zcm5bin">
            Five operational volumes, 800+ pages, sequenced so the highest-return work comes first.
          </p>
        </Reveal>

        <ul className="mt-10 grid grid-cols-1 gap-x-10 lg:grid-cols-2" data-id="element-83" data-mp="146nr9scqy4mb">
          {volumes.map((volume, i) => <li key={volume.n} className="border-t border-white/10" data-id="element-84" data-mp="2zuifmw7zpqvi" data-mpi={i}>
              <Reveal delay={i * 0.04} data-id="element-85" data-mp="2vv9ntwwig32l">
                <article className="py-4" data-id="element-86" data-mp="2vu80asyb5o3z">
                  <div className="flex items-start gap-3" data-id="element-87" data-mp="39lldzq9jbrr3">
                    <img src={volume.image} alt={`Cover of ${volume.title}`} className="h-[88px] w-16 shrink-0 rounded-md object-cover ring-1 ring-white/15 sm:h-24 sm:w-[72px]" width={144} height={192} loading="lazy" data-id="element-88" data-mp="39nz9u1c1h7zp" />
                    <div className="min-w-0 flex-1" data-id="element-89" data-mp="2cvlwv7fbjkww">
                      <p className="text-[10px] font-bold uppercase tracking-[0.18em]" style={{
                    color: volume.color
                  }} data-id="element-90" data-mp="2cwxas02ha91q">
                        Vol {volume.n} · {volume.pages}
                      </p>
                      <h3 className="mt-1 text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-base" data-id="element-91" data-mp="2lyn45bfx7i25">
                        {volume.title}
                      </h3>
                      <p className="mt-1.5 text-[12.5px] leading-[1.45] text-slate-300" data-id="element-92" data-mp="18fjba2r63oc">{volume.description}</p>
                    </div>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>

        <Reveal className="mt-10" data-id="element-93" data-mp="i75x8k4kdgkx">
          <PriceOffer data-id="element-94" data-mp="i7yv0vljovqx" />
        </Reveal>

        <div className="mt-20 border-t border-white/10 pt-14" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "26px",
        marginBottom: "26px"
      }} data-id="element-95" data-mp="n6iln9b32vpm">
          <Reveal className="max-w-3xl" data-id="element-96" data-mp="3lmbdrnsov0vm">
            <h3 className="text-2xl font-black tracking-tight text-white sm:text-3xl" data-id="element-97" data-mp="3qmh5t52vepe8">
              Plus 5 exclusive bonuses{' '}
              <span className="align-middle text-sm font-bold uppercase tracking-widest text-brand-gold" data-id="element-98" data-mp="3vl0w1hohynce">
                Limited time
              </span>
            </h3>
            <p className="mt-3 text-lg leading-relaxed text-slate-300" data-id="element-99" data-mp="32wmyt458fv1w">
              $147 of additional assets, included free with the system today.
            </p>
          </Reveal>

          <ul className="mt-6 grid grid-cols-1 gap-x-10 lg:grid-cols-2" data-id="element-100" data-mp="30di5x0xmwr32">
            {bonuses.map((bonus, i) => <li key={bonus.title} className="border-t border-white/10" data-id="element-101" data-mp="2vdvrwp9zf6t7" data-mpi={i}>
                <Reveal delay={i * 0.04} data-id="element-102" data-mp="2qf2gr3i63rw7">
                  <article className="py-4" data-id="element-103" data-mp="2qdr9gtpik20c">
                    <div className="flex items-start gap-3" data-id="element-104" data-mp="2qgvji7pntryx">
                      <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-[88px] w-16 shrink-0 rounded-md object-cover ring-1 ring-white/15 sm:h-24 sm:w-[72px]" width={144} height={192} loading="lazy" data-id="element-105" data-mp="2lffzmiz7xri4" />
                      <div className="min-w-0 flex-1" data-id="element-106" data-mp="2clktb7md1v0w">
                        <p className="text-[10px] font-bold uppercase tracking-[0.18em]" style={{
                      color: bonus.color
                    }} data-id="element-107" data-mp="27nrmqdh5az03">
                          Bonus {i + 1} ·{' '}
                          <span className="font-semibold text-slate-400 line-through decoration-slate-500" data-id="element-108" data-mp="1xpbxkg1ohzt8">{bonus.value}</span>{' '}
                          <span className="text-white" data-id="element-109" data-mp="1tqweuocmrdlm">free</span>
                        </p>
                        <h4 className="mt-1 text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-base" data-id="element-110" data-mp="2ig7pm3fznelt">
                          {bonus.title}
                        </h4>
                        <p className="mt-1.5 text-[12.5px] leading-[1.45] text-slate-300" data-id="element-111" data-mp="29l1hgxt8wkg4">{bonus.description}</p>
                      </div>
                    </div>
                  </article>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}